import { Outlet } from "react-router-dom";
import { MobileBottomNav } from "./MobileBottomNav";
import { MobileHeader } from "./MobileHeader";
import { DesktopSidebar } from "./DesktopSidebar";
import { DesktopHeader } from "./DesktopHeader";
import { PageTransition } from "@/components/carmel/PageTransition";
import { useSwipeBack } from "@/hooks/useSwipeBack";

export function UserPortalLayout() {
  useSwipeBack();
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-[var(--background)]">
      {/* Desktop sidebar */}
      <DesktopSidebar />

      {/* Main area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Desktop header */}
        <DesktopHeader />

        {/* Mobile header */}
        <MobileHeader />

        {/* Scrollable content */}
        <main id="main-content" className="flex-1 overflow-y-auto overflow-x-hidden scroll-container">
          <div className="mx-auto w-full max-w-[var(--page-max-width)] p-4 pb-24 md:p-6 md:pb-6">
            <PageTransition><Outlet /></PageTransition>
          </div>
        </main>
      </div>

      {/* Mobile bottom navigation */}
      <MobileBottomNav />
    </div>
  );
}
